"use client";
import { useCheckboxContext } from "./use-checkbox-context.js";
//#region src/components/checkbox/checkbox-context.tsx
var CheckboxContext = (props) => props.children(useCheckboxContext());
//#endregion
export { CheckboxContext };
